import { FC } from 'react'
import styled from 'styled-components'
import { useCheckDesktop } from 'utils/hooks/useMediaQuery'
import { ProductViewImageFragment } from 'api/operations'
import { getImageSrc } from 'utils/screen'
import NoWine from '../../../Icons/NoWine'
import breakpoints from 'utils/consts/breakpoints'
import {
  CarouselProvider,
  DotGroup,
  Image as ImageSlider,
  Slide,
  Slider,
} from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'

const Image = styled.img`
  object-fit: contain;
  object-position: center;
  width: 100%;
  height: 100%;
`

const ImageWrapper = styled.div`
  flex: 1;
  overflow: hidden;
`

const CarouselWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100%;

  .slider {
    width: 448px;
  }

  .slider-image {
    object-fit: contain;
    object-position: center;
  }

  .carousel__dot-group {
    margin-top: 19px;
    display: flex;
    justify-content: center;
    column-gap: 10px;

    button {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      padding: 0;
      border: 0;
      appearance: none;
      outline: none;
      background: #d8d9ed;
    }

    .carousel__dot--selected {
      background: #3b42a5;
    }
  }

  @media screen and ${breakpoints.device.mobile} {
    .slider {
      width: 320px;
    }
  }
`

interface CarouselProps {
  images: ProductViewImageFragment[]
  selectedImage: number
}

const Carousel: FC<CarouselProps> = ({ images, selectedImage }) => {
  const image = images?.[selectedImage]

  const isDesktop = useCheckDesktop()

  return (
    <ImageWrapper>
      {isDesktop ? (
        <>
          {image ? (
            <Image key={selectedImage} {...getImageSrc(image)} />
          ) : (
            <NoWine />
          )}
        </>
      ) : (
        <CarouselWrapper>
          {images.length > 0 ? (
            <CarouselProvider
              visibleSlides={1}
              step={images.length}
              naturalSlideWidth={100}
              naturalSlideHeight={100}
              totalSlides={images.length}
            >
              <Slider className={'slider'}>
                {images.map((image, index) => (
                  <Slide key={index} index={index}>
                    <ImageSlider
                      {...getImageSrc(image)}
                      className='slider-image'
                      hasMasterSpinner={false}
                    />
                  </Slide>
                ))}
              </Slider>
              <DotGroup />
            </CarouselProvider>
          ) : (
            <NoWine />
          )}
        </CarouselWrapper>
      )}
    </ImageWrapper>
  )
}

export default Carousel
